import { Routes, Route } from 'react-router-dom';
import './App.css';

// Import pages
import Home from './pages/Home/Home';
import QandA from './pages/QandA/QandA';
import Tools from './pages/Tools/Tools';
import CaseStudies from './pages/CaseStudies/CaseStudies';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import { Blog, BlogPost } from './pages/Blog';
// Temporarily comment out auth imports
// import SignIn from './pages/Auth/SignIn';
// import SignUp from './pages/Auth/SignUp';
// import ForgotPassword from './pages/Auth/ForgotPassword';
// import Profile from './pages/Profile/Profile';

// Import layout component
import Layout from './components/layout/Layout';
// Temporarily comment out auth context
// import { useAuth } from './context/AuthContext';

// Temporarily disable protected route
// const ProtectedRoute = ({ children }) => {
//   const { currentUser } = useAuth();
//   
//   if (!currentUser) {
//     return <Navigate to="/signin" />;
//   }
//   
//   return children;
// };

function App() {
  return (
    <Routes>
      <Route path="/" element={
        <Layout>
          <Home />
        </Layout>
      } />
      <Route path="/qanda" element={
        <Layout>
          <QandA />
        </Layout>
      } />
      <Route path="/tools" element={
        <Layout>
          <Tools />
        </Layout>
      } />
      <Route path="/case-studies" element={
        <Layout>
          <CaseStudies />
        </Layout>
      } />
      <Route path="/blog" element={
        <Layout>
          <Blog />
        </Layout>
      } />
      <Route path="/blog/:id" element={
        <Layout>
          <BlogPost />
        </Layout>
      } />
      <Route path="/privacy-policy" element={
        <Layout>
          <PrivacyPolicy />
        </Layout>
      } />
      <Route path="/terms-and-conditions" element={
        <Layout>
          <TermsAndConditions />
        </Layout>
      } />
      {/* Temporarily comment out auth routes
      <Route path="/signin" element={
        <Layout>
          <SignIn />
        </Layout>
      } />
      <Route path="/signup" element={
        <Layout>
          <SignUp />
        </Layout>
      } />
      <Route path="/forgot-password" element={
        <Layout>
          <ForgotPassword />
        </Layout>
      } />
      <Route path="/profile" element={
        <Layout>
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        </Layout>
      } />
      */}
    </Routes>
  );
}

export default App;
